import { type StaticImageData } from "next/image";
import floralsMobile from "@assets/images/sweepstakes/florals-mobile.webp";
import florals from "@assets/images/sweepstakes/florals.webp";
import bagPassPanelMobile from "@assets/images/popup-test/popup-bag-pass-mobile.webp";
import bagPassPanel from "@assets/images/popup-test/popup-bag-pass.webp";
import maticCarePanelMobile from "@assets/images/popup-test/popup-matic-care-mobile.webp";
import maticCarePanel from "@assets/images/popup-test/popup-matic-care.webp";
import giftQuizPanelMobile from "@assets/images/popup-test/popup-gift-quiz-mobile.webp";
import giftQuizPanel from "@assets/images/popup-test/popup-gift-quiz.webp";
import giftBagPass from "@assets/images/popup-test/gift-bag-pass.webp";
import giftMaticCare from "@assets/images/popup-test/gift-matic-care.webp";
import giftDock from "@assets/images/popup-test/gift-dock.webp";
import giftPetBundle from "@assets/images/popup-test/gift-pet-bundle.webp";
import type { PopupGift, PopupVariant } from "@/utils/popupOffers";

export type PopupPanel = {
  desktop: StaticImageData;
  mobile: StaticImageData;
  /** Dark photos take a white close button below `xl`; light ones a dark one. */
  tone: "dark" | "light";
  /**
   * A photo fills its panel and crops; a gift composition shows whole on the
   * panel's matching background, since its badges sit near the edges.
   */
  fit: "cover" | "contain";
};

const FLORALS: PopupPanel = {
  desktop: florals,
  mobile: floralsMobile,
  tone: "dark",
  fit: "cover",
};

const giftPanel = (
  desktop: StaticImageData,
  mobile: StaticImageData,
): PopupPanel => ({ desktop, mobile, tone: "light", fit: "contain" });

export const POPUP_PANELS: Record<PopupVariant, PopupPanel> = {
  A: FLORALS,
  B: FLORALS,
  C: giftPanel(bagPassPanel, bagPassPanelMobile),
  D: giftPanel(maticCarePanel, maticCarePanelMobile),
  E: giftPanel(giftQuizPanel, giftQuizPanelMobile),
};

export const GIFT_BADGES: Record<PopupGift, StaticImageData> = {
  bag_pass: giftBagPass,
  matic_care: giftMaticCare,
  dock: giftDock,
  pet_bundle: giftPetBundle,
};
